import {SguaiAdapter} from "./sguaiAdapter";

export const pixelDisplayAdapters = [
  {
    id: "sguai",
    name: "SGUAI",
    create: () => new SguaiAdapter(),
  },
];

export const createDefaultAdapter = () => pixelDisplayAdapters[0].create();
